<template>
  <div class="shoppe" v-loading.fullscreen.lock="fullscreenLoading">
    <el-form class="query-form" label-position="right" label-width="40px">
      <el-row :gutter="20">
        <el-col :xs="24" :sm="24" :md="24" :lg="20" :xl="20">
          <el-row :gutter="10">
            <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
              <el-form-item label="状态">
                <el-select v-model="queryForm.processResult" clearable placeholder="请选择">
                  <el-option label="未处理" :value="0"></el-option>
                  <el-option label="处理中" :value="1"></el-option>
                  <el-option label="已完结" :value="2"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-col>
        <el-col :xs="24" :sm="24" :md="24" :lg="4" :xl="4">
          <el-button @click="search" type="primary">查询</el-button>
          <el-button @click="reset">重置</el-button>
        </el-col>
      </el-row>
    </el-form>

    <div>
      <el-button @click="exportData" :loading="exportLoading" type="primary">导出</el-button>
    </div>

    <el-table :data="tableData">
      <el-table-column prop="createTime" label="时间">
        <template slot-scope="scope">
          {{ dateFormat(scope.row.createTime) }}
        </template>
      </el-table-column>
      <el-table-column prop="vendorName" label="卖家名称"></el-table-column>
      <el-table-column prop="feedbackModuleName" label="反馈模块"></el-table-column>
      <el-table-column prop="feedbackContent" label="反馈内容"></el-table-column>
      <el-table-column prop="feedbackImageUrls" label="反馈图片" class-name="nopadding">
        <template slot-scope="scope">
          <list-img :img="scope.row.feedbackImageUrls" :width="30" :limit="5"></list-img>
        </template>
      </el-table-column>
      <el-table-column prop="mobile" label="手机号">
        <template slot-scope="scope">
          <el-link type="primary" @click="showMobile(scope.row)">{{ scope.row.mobile }}</el-link>
        </template>
      </el-table-column>
      <el-table-column prop="contactPhoneNum" label="联系方式">
        <template slot-scope="scope">
          <el-link type="primary" @click="showContact(scope.row)">{{ scope.row.contactPhoneNum }}</el-link>
        </template>
      </el-table-column>
      <el-table-column prop="processResult" label="处理结果">
        <template slot-scope="scope">
          <span v-if="scope.row.processResult === 0">未处理</span>
          <span v-if="scope.row.processResult === 1">处理中</span>
          <span v-if="scope.row.processResult === 2">已完结</span>
        </template>
      </el-table-column>
      <el-table-column prop="remark" label="备注"></el-table-column>
      <el-table-column prop="replyContent" label="回复短信"></el-table-column>
      <el-table-column prop="opUserName" label="操作人"></el-table-column>
      <el-table-column prop="" label="操作">
        <template slot-scope="scope">
          <el-link type="primary" @click="dealWithItem(scope.row)">处理</el-link>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination class="tr"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="queryForm.pageNo"
      :page-sizes="[10, 25, 50, 100]"
      :page-size="queryForm.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total">
    </el-pagination>

    <el-dialog append-to-body title="处理" :visible.sync="dialogVisible" width="500px" :close-on-click-modal="false">
      <el-form ref="form" :model="form" label-width="80px">
        <el-form-item label="反馈模块">{{ form.feedbackModuleName }}</el-form-item>
        <el-form-item label="反馈内容">{{ form.feedbackContent }}</el-form-item>
        <el-form-item label="反馈图片">
          <list-img style="text-align: left;" :img="form.feedbackImageUrls" :width="30" :limit="999"></list-img>
        </el-form-item>
        <el-form-item prop="processResult" label="处理结果" :rules="[{ required: true, message: '请选择处理结果' }]">
          <el-select v-model="form.processResult" placeholder="请选择">
            <el-option label="未处理" :value="0"></el-option>
            <el-option label="处理中" :value="1"></el-option>
            <el-option label="已完结" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="remark" label="备注">
          <el-input type="textarea" v-model="form.remark" :rows="3" :maxlength="1000"></el-input>
        </el-form-item>
        <el-form-item prop="replyContent" label="回复短信">
          <el-input type="textarea" v-model="form.replyContent" :disabled="replied" :rows="3" :maxlength="1000"></el-input>
          <p class="f12">注意：填写之后保存，就会发送短信，不能修改。</p>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submit">确认</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import utils from '@/utils/util';
import { downloadUrlFile } from '@/utils/functions';
import {
  getFeedbackList,
  submitFeedbackProcess,
  getMobile,
  getContactPhoneNum,
  exportFeedbackList,
} from "./api";
import ListImg from '../shared/ListImg.vue';

export default {
  components: {
    ListImg,
  },
  data() {
    return {
      fullscreenLoading: false,
      queryForm: {
        processResult: null,
        pageNo: 1,
        pageSize: 25,
      },
      tableData: [],
      total: 0,
      dialogVisible: false,
      form: {
        sellerSuggestFeedbackId: null,
        feedbackModuleName: null,
        feedbackContent: null,
        feedbackImageUrls: [],
        processResult: null,
        remark: null,
        replyContent: null,
      },
      replied: false,
      exportLoading: false,
    };
  },
  mounted() {
    this.getTableData();
  },
  methods: {
    search() {
      this.queryForm.pageNo = 1;
      this.getTableData();
    },
    reset() {
      this.queryForm.processResult = null;
      this.queryForm.pageNo = 1;
      this.getTableData();
    },
    getTableData() {
      getFeedbackList(this.queryForm).then(res => {
        if (res.data && res.data.data) {
          this.total = res.data.data.total;
          this.tableData = res.data.data.list;
        }
      })
    },
    handleSizeChange(pageSize) {
      this.queryForm.pageSize = pageSize;
      this.getTableData();
    },
    handleCurrentChange(pageNo) {
      this.queryForm.pageNo = pageNo;
      this.getTableData();
    },
    dateFormat(time) {
      if (!time) {
        return '';
      }
      return utils.dateFormat(new Date(time), 'yyyy-MM-dd hh:mm:ss');
    },
    dealWithItem(row) {
      this.form.sellerSuggestFeedbackId = row.sellerSuggestFeedbackId;
      this.form.feedbackModuleName = row.feedbackModuleName;
      this.form.feedbackContent = row.feedbackContent;
      this.form.feedbackImageUrls = row.feedbackImageUrls;
      this.form.processResult = row.processResult;
      this.form.remark = row.remark || null;
      if (row.replyContent) {
        this.form.replyContent = row.replyContent;
        this.replied = true;
      } else {
        this.form.replyContent = null;
        this.replied = false;
      }
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.form.clearValidate();
      });
    },
    submit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          submitFeedbackProcess({
            sellerSuggestFeedbackId: this.form.sellerSuggestFeedbackId,
            processResult: this.form.processResult,
            remark: this.form.remark,
            replyContent: this.form.replyContent,
          }).then(res => {
            if (res.data && res.data.success) {
              this.$message.success('提交成功');
              this.dialogVisible = false;
              this.getTableData();
            } else {
              this.$message.error(res.data.message || '系统异常，请稍后再试');
            }
          })
        }
      })
    },
    showMobile(row) {
      getMobile(row.appUserId).then(res => {
        if (res.data && res.data.success) {
          this.$alert(`手机号：${res.data.data}`, '警告', {
            type: 'warning',
            confirmButtonText: '确定',
          });
        }
      });
    },
    showContact(row) {
      getContactPhoneNum({
        sellerSuggestFeedbackId: row.sellerSuggestFeedbackId,
      }).then(res => {
        if (res.data && res.data.success) {
          this.$alert(`联系方式：${res.data.data}`, '警告', {
            type: 'warning',
            confirmButtonText: '确定',
          });
        }
      });
    },
    exportData() {
      this.exportLoading = true;
      exportFeedbackList(this.queryForm).then(res => {
        if (res.data && res.data.success) {
          downloadUrlFile(res.data.data);
        }
        this.exportLoading = false;
      })
    },
  },
};
</script>
<style lang="less" scoped>
.shoppe {
  padding: 20px;
}
.tr {
  margin-top: 10px;
  text-align: right;
}
.ml10 {
  margin-left: 10px;
}
.f12 {
  font-size: 12px;
}
</style>
